export const Title = () => {
	return (
		<div style={{ display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "center", marginBottom: "20px" }}>
			<span style={{ 
				fontSize: "70px", 
				color: "white", 
				textAlign: "center",
				// WebkitTextStroke: "5px black",
				// WebkitTextFillColor: "white",
				}}>PIPE RACER</span>
		</div>
	)
}